import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Hero from "../components/Hero";
import RatesTable from "../components/RatesTable";
import AboutSection from "../components/AboutSection";
import MoneyGramSection from "../components/MoneyGramSection";
import LoyaltySection from "../components/LoyaltySection";
import LocationsGrid from "../components/LocationsGrid";
import SEO from "../components/SEO";
import { useLang } from "../contexts/LangContext";
import { LOCATIONS } from "../data/locations";

const Home = () => {
  const { lang } = useLang();
  const [rates, setRates] = useState([]);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [bnrDate, setBnrDate] = useState(null);

  const loadAll = async () => {
    try {
      const r = await api.get("/rates");
      setRates(r.data.rates || []);
      setLastUpdate(r.data.last_update);
      setBnrDate(r.data.bnr_last_update);
    } catch (e) {
      console.error("Home load failed", e);
    }
  };

  useEffect(() => {
    loadAll();
  }, []);

  const topRates = rates.filter((r) => ["EUR", "USD", "GBP", "CHF"].includes(r.code));

  return (
    <div data-testid="home-page">
      <SEO
        title={
          lang === "en"
            ? "Live currency exchange in Constanta — since 1995"
            : "Schimb valutar in Constanta — din 1995"
        }
        description={
          lang === "en"
            ? "Corsa Exchange — 30 years of trusted currency exchange in Constanta, Navodari and Mangalia. 14 currencies, live BNR rates, 12 branches, MoneyGram international transfers."
            : "Corsa Exchange — 30 de ani de schimb valutar de incredere in Constanta, Navodari si Mangalia. 14 valute, curs BNR live, 12 puncte de lucru, transfer rapid MoneyGram."
        }
      />
      <Hero topRates={topRates} rates={rates} />
      <RatesTable rates={rates} lastUpdate={lastUpdate} bnrDate={bnrDate} />
      <hr className="border-t border-[#5a1a14]/15 mx-6 lg:mx-10" />
      <AboutSection />
      <MoneyGramSection />
      {/* <LoyaltySection /> */}
      <LocationsGrid locations={LOCATIONS} />
    </div>
  );
};

export default Home;
